<template>
    <div class="page">
        <img class="panel__logo" src="http://cdn.airfunc.com/51595166798_.pic_hd.jpg">
        <div class="panel">
            <div class="panel__header">
                <h2 class="panel__title">Hi hiro,</h2>
            </div>
            <div class="panel__content">
                <template comment="推送">
                    <p>我发布了最新的文章，快来看看吧！</p>
                    <img src="//cdn.airfunc.com/876bba1c6ae7475f8c50ed7b64cbf72e">
                    <h2 class="panel__title">CSS3基础</h2>
                    <p>本文主要介绍了如何利用css3实现一个等边六边形以及如何计算组成等边六形矩形的宽高。</p>
                    <div class="panel__row">
                        <a href="http://blog.airfunc.com"
                           class="panel__button">
                            立即浏览
                        </a>
                    </div>
                    <p class="panel__sub-text panel__text-center panel__margin-top">
                        Copyright © 2020. All Rights Reserved.</p>
                    <p class="panel__text-center">
                        <a class="panel__sub-text"
                           href="http://blog.airfunc.com/unsubscribe?subscribe="
                        >
                            退订
                        </a>
                    </p>
                    <!--                    //cdn.airfunc.com/876bba1c6ae7475f8c50ed7b64cbf72e-->
                </template>
                <template comment="评论" v-if="false">
                    <p class="m-b-0"></p>
                    <p class="panel__text-primary">什么东西下想消息想想想新</p>
                    <div class="panel__row m-t-60">
                        <a href="http://blog.airfunc.com/subscribe"
                           class="panel__button">
                            查看详情
                        </a>
                    </div>
                    <p class="panel__sub-text panel__text-center panel__margin-top">
                        Copyright © 2020. All Rights Reserved.</p>
                </template>
                <template comment="回复" v-if="false">
                    <p class="m-b-0">有人评论了您的文章《css3基础》：</p>
                    <p class="panel__text-primary">什么东西下想消息想想想新</p>
                    <div class="panel__row m-t-60">
                        <a href="http://blog.airfunc.com/subscribe"
                           class="panel__button">
                            查看详情
                        </a>
                    </div>
                    <p class="panel__sub-text panel__text-center panel__margin-top">
                        Copyright © 2020. All Rights Reserved.</p>
                </template>
                <template comment="回复" v-if="false">
                    <p class="m-b-0">有人回复了您在《css3基础》的评论：</p>
                    <p class="panel__text-primary">什么东西下想消息想想想新</p>
                    <p class="m-b-0">回复内容：</p>
                    <p class="panel__text-primary">什么东西下想112313消息想想想新</p>
                    <div class="panel__row m-t-60">
                        <a href="http://blog.airfunc.com/subscribe"
                           class="panel__button">
                            查看详情
                        </a>
                    </div>
                    <p class="panel__sub-text panel__text-center panel__margin-top">
                        Copyright © 2020. All Rights Reserved.</p>
                </template>
                <template comment="退订成功" v-if="false">
                    <p>很抱歉看到您的退订。</p>
                    <p>您将不再收到AirFunc Blog有关新博客发布的电子邮件。</p>
                    <p>AirFunc Blog 期待您的再次订阅！ :-)</p>
                    <div class="panel__row">
                        <a href="http://blog.airfunc.com/subscribe"
                           class="panel__button">
                            再次订阅
                        </a>
                    </div>
                    <p class="panel__sub-text panel__text-center panel__margin-top">
                        Copyright © 2020. All Rights Reserved.</p>
                </template>


                <template comment="订阅成功" v-if="false">
                    <p>您已成功订阅AirFunc Blog！您会收到我关于新博客发布相关的电子邮件。</p>
                    <p>文章内容将以每周至少一篇的进度进行更新。内容将会以技术分享为主，好物分享（优质书籍、github 开源项目、优秀文章等）为辅，敬请期待。</p>
                    <p>对于文章中的问题可以通过邮件、issues、博客评论提出，我会在第一时间回复。</p>
                    <p>我发送的有关新博客发布的每封电子邮件的底部都将提供退订链接。如果您不想收到与此有关的电子邮件，请随时使用它！</p>
                    <div class="panel__row">
                        <a href="http://blog.airfunc.com"
                           class="panel__button">
                            立即浏览
                        </a>
                    </div>
                    <p class="panel__sub-text panel__text-center panel__margin-top">
                        Copyright © 2020. All Rights Reserved.</p>
                    <p class="panel__text-center">
                        <a class="panel__sub-text"
                           href="http://blog.airfunc.com/unsubscribe?subscribe="
                        >
                            退订
                        </a>
                    </p>
                </template>

                <template comment="订阅确认" v-if="false">
                    <p>感谢您订阅AirFunc Blog！在开始之前，我们需要确认您的身份。点击下方的按钮以验证电子邮箱:</p>
                    <div class="panel__row">
                        <a href="http://blog.airfunc.com/confirm-subscribe?subscribe=128301839012381"
                           class="panel__button">
                            验证电子邮箱地址
                        </a>
                    </div>
                    <p class="panel__sub-text">
                        如果按钮不起作用，请将以下链接复制粘贴至浏览器：
                    </p>
                    <p class="panel__sub-text">
                        http://blog.airfunc.com/confirm-subscribe?subscribe=128301839012381
                    </p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "index"
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";


    * {
        margin: 0;
        padding: 0;
        text-decoration: none;
        color: $secondaryTextColor;
        font-family: Quicksand, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    }

    p {
        margin-bottom: $paddingMD;
    }

    a {
        text-decoration: none !important;
    }

    img{
        width: 100%;
    }

    html, body {
        background-color: $componentBackgroundColor;
    }

    .page {
        padding: $paddingMD;
        background-color: $componentBackgroundColor;
    }

    .m-b-0 {
        margin-bottom: 0;
    }

    .m-t-60 {
        margin-top: 60px !important;
    }

    .panel {
        padding: $paddingMD;
        background-color: #fff;
        border-radius: $radius;
        max-width: 600px;
        margin: $paddingMD auto 0;
        color: $secondaryTextColor;
        line-height: 2;

        &__header {
            margin-bottom: $paddingLG;
        }

        &__title {
            font-size: $fontSizeMD;
            color: $textColor;
        }

        &__sub-title {
            font-size: $fontSizeCommon;
            color: $secondaryTextColor;
        }

        &__button {
            display: inline-block;
            text-align: center;
            padding: 0.5rem 1rem;
            border-radius: 0.25rem;
            color: #fff !important;
            background-color: #07A377;
        }

        &__row {
            margin: $paddingMD 0;
            text-align: center;
        }

        &__sub-text {
            font-size: $fontSizeSM;
            margin-bottom: 0;
        }

        &__text-center {
            text-align: center;
        }

        &__margin-top {
            margin-top: $paddingSP;
        }

        &__text-primary {
            color: $primaryColor;
        }
    }

    .panel__logo {
        display: block;
        width: 150px;
        margin: 0 auto;
    }
</style>